<template>
    <el-dialog
        title="企业列表"
        :visible.sync="dialogVisible"
        width="1000px" :close-on-click-modal="false" @close="dialogClose">
        <div class="orderManagementClass">
            <div class="orderManagementContent">
                <div class="printOrderListBox">
                    <div>
                        <div class="orderSearchBox">
                            <el-input v-model="enterpriseName" clearable placeholder="企业名称"></el-input>
                            <el-input v-model="tel" clearable placeholder="手机号"></el-input>
                            <el-button class="searchBtn" @click="getShopProvidersList">搜索</el-button>
                            <el-button type="text" class="resetBtn" @click="resetData">
                                <i class="iconfont icon-qingchushujuku"></i>
                                <span>清除条件</span>
                            </el-button>

                        </div>
                        <div class="orderListTable">
                            <el-table
                                :data="tableData"
                                border
                                style="width: 100%" class="tableContent">
                                <el-table-column
                                    prop="enterpriseName"
                                    label="企业名称"
                                    width="300"
                                    header-align="center"
                                    show-overflow-tooltip
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="tel"
                                    label="手机号"
                                    header-align="center"
                                    show-overflow-tooltip
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="email"
                                    label="邮箱"
                                    header-align="center"
                                    show-overflow-tooltip
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="createdDate"
                                    align="center"
                                    header-align="center"
                                    label="注册时间">
                                </el-table-column>
                                <el-table-column
                                    label="操作"
                                    header-align="center"
                                    align="center"
                                    width="100">
                                    <template slot-scope="scope">
                                        <el-button type="text" size="small" @click="updateContractor(scope.row.uuid)">添加</el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                            <el-pagination
                                background
                                @current-change="handleCurrentChange"
                                @prev-click="handleCurrentChange"
                                @next-click="handleCurrentChange"
                                layout="total,prev, pager, next,jumper"
                                :current-page="current"
                                :page-size="pageSize"
                                :total="total" class="pagination">
                            </el-pagination>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </el-dialog>
</template>

<script>
import { getContractorList,updateContractor} from '../../../utils/interface';
export default {
    name: 'contractorDialog',
    components: {},
    data() {
        return {
            loading: false,
            enterpriseName:'',
            tel: '',
            tableData: [],
            current:1,
            total: 0,
            pageSize: 5,
            dialogVisible: false,
        }
    },

    methods: {
        init(){
            this.resetData();
            this.dialogVisible=true;
        },
        getShopProvidersList(){
            let params = {
                current:this.current,
                pageSize:this.pageSize,
                enterpriseName:this.enterpriseName,
                tel: this.tel,
                identity:'ENTERPRISE',
                contract:false
            };
            getContractorList(params).then((res)=>{
                this.tableData = res.data;
                this.total = res.total;
                this.pageSize = res.pageSize;
                this.current = res.current;
            });
        },
        dialogClose(){
            this.$emit("refreshManager");
        },
        updateContractor(uuid){
            updateContractor(uuid).then(res=>{
                if (res.success) {
                    this.$message.success('添加成功！');
                    this.getShopProvidersList();
                }else{
                    this.$message.error('添加失败！');
                }
            });
        },
        resetData(){
            this.enterpriseName='';
            this.tel = '';
            this.getShopProvidersList();
        },
        toDialog(){
            this.dialogVisible = true;
            this.loading = true;
            this.title = '企业列表'
        },
        // 分页
        handleCurrentChange(val){
            this.current = val;
            this.getShopProvidersList();
        }
    }
}
</script>

<style scoped lang="less">
.orderManagementClass {
    position: relative;
    width: 100%;
    padding: 0 20px 20px;
    .orderManagementContent {
        background: #fff;
        .printOrderListBox {
            padding: 20px;
            .orderSearchBox {
                .timeSearch {
                    background-color: #f2f4f7;
                    height: 35px;
                    display: flex;
                    align-items: center;
                    margin-bottom: 22px;
                    margin-right: 30px;
                    border-radius: 8px;

                    span {
                        font-size: 12px;
                        color: #c0c4cc !important;
                        font-weight: normal;
                        padding-left: 15px;
                        margin-right: 5px;
                    }

                    // /deep/ .el-range-input{
                    //         background-color: #f2f4f7;
                    //             &:hover, &:focus {
                    //             background-color: #fff;
                    //             // border: 1px solid #108EE9;
                    //         }
                    // }
                    /deep/ input::-webkit-input-placeholder {
                        color: #c0c4cc;
                        font-size: 12px;
                    }

                    /deep/ .el-range-input:hover {
                        background-color: #fff !important;
                    }

                    /deep/ .el-date-editor .el-range-separator {
                        line-height: 25px;
                        color: #c0c4cc;
                    }

                    /deep/ .el-date-editor .el-range__close-icon {
                        line-height: 28px;
                    }

                    /deep/ .el-input__inner:hover .el-range-input, /deep/ .el-input__inner:focus .el-range-input {
                        background-color: white;
                    }

                    /deep/ .el-input__inner {
                        width: 225px;
                        height: 35px;
                        min-height: 35px;
                        font-size: 12px;
                        color: #999999;
                        background-color: #f2f4f7;
                        border: 1px solid #f2f4f7;
                        border-radius: 5px;

                        .el-range-input {
                            background-color: #f2f4f7;
                        }

                        &:hover, &:focus {
                            background-color: #fff;
                            border: 1px solid #108EE9;

                        }
                    }
                }
                display: flex;
                flex-wrap: wrap;

                /deep/ .el-input {
                    width: initial;
                    margin-bottom: 22px;
                    margin-right: 30px;
                }

                /deep/ .el-input__inner {
                    width: 242px;
                    height: 35px;
                    min-height: 35px;
                    font-size: 12px;
                    color: #999999;
                    background-color: #f2f4f7;
                    border: 1px solid #f2f4f7;
                    border-radius: 5px;

                    &:hover, &:focus {
                        background-color: #fff;
                        border: 1px solid #108EE9;
                    }
                }

                /deep/ .el-input__prefix {
                    top: -3px;
                }

                /deep/ .el-input__suffix {
                    top: 2px;
                }

                /deep/ .el-button {
                    display: block;
                    line-height: 35px;
                    padding: 0;
                    height: 35px;
                }

                .searchBtn {
                    width: 82px;
                    background: #3d7fff;
                    border: none;
                    border-radius: 15px;
                    font-size: 14px;
                    color: #FFFFFF;
                    margin-bottom:22px;
                }

                .resetBtn {
                    color: #333333;
                    margin-bottom:22px;
                }
            }
            .pagination {
                margin-top: 20px;
                text-align: right;
            }
        }
    }
    .tableTool {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        margin-bottom: 20px;
        .toolRight {
            button {
                width: 83px;
                height: 30px;
                background: rgba(21, 126, 251, 1);
                border: none;
                border-radius: 15px;
                font-size: 13px;
                color: #fff;

                i {
                    padding-right: 5px;
                }

                &:hover {
                    background: #61a2f0;
                }
            }
        }
    }
    //审核查看详情中title的样式
    /deep/.el-dialog__header{
        border-bottom: 1px solid #ddd;
        .el-dialog__title{
            color: #000;
            font-weight: 700;
            font-size: 16px;

        }
    }
    .dialogBox{
        .details{
            .detailsItem{
                padding-bottom: 20px;
                h3{
                    font-weight: 700;
                    font-size: 16px;
                    color: #000;
                    margin-top: 0;
                    letter-spacing: 1px;
                    // border-bottom: 1px solid #ddd;
                    padding-bottom: 15px;
                }
                .itemContent{
                    display: flex;
                    flex-wrap: wrap;
                    font-size: 15px;
                    // padding: 0 30px;
                    .one-row{
                        width: 50%;
                        margin-bottom: 22px;
                        display: flex;
                        font-size: 14px;
                        .label{
                            padding-right: 15px;
                            min-width: 110px;
                            color: rgba(0, 0, 0, 0.85);
                        }
                        .name{
                            // color: #000;
                            color: rgba(0, 0, 0, 0.65);
                        }
                    }
                    .two-row{
                        width: 50%;
                        margin-bottom: 22px;
                        display: flex;
                        font-size: 14px;
                        .label{
                            padding-right: 15px;
                            min-width: 110px;
                            color: rgba(0, 0, 0, 0.85);
                        }
                        .name{
                            // color: #000;
                            caret-color: rgba(0, 0, 0, 0.65);
                        }
                    }
                }
            }
        }
        .audit{
            padding-bottom: 20px;
            h3{
                font-weight: 700;
                font-size: 16px;
                color: #000;
                margin-top: 0;
                letter-spacing: 1px;
                // border-bottom: 1px solid #ddd;
                padding-bottom: 15px;
            }
            .auditContent{
                // padding: 0 30px;
            }
            .cause{
                display: flex;
                margin-top: 20px;
                .causeTitle{
                    min-width: 80px;
                    color: #3a8ee6;
                }
                .causeContent{
                    color: #000;
                }
            }
            .auditEnter{
                text-align: center;
                padding-top: 20px;
                button{
                    width: 120px;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/shopManager/dialog/contractorDialog.vue